var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipsisBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.25a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM8.25 13a.75.75 0 000 1.5h3.5a.75.75 0 000-1.5h-3.5z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.824 18.226l-.543.543c-.856.856-1.285 1.285-1.314 1.653a1 1 0 00.348.838c.28.24.886.24 2.098.24H12A9.5 9.5 0 102.5 12c0 2.382.876 4.558 2.324 6.226zm2.05.072L5.171 20H12a8 8 0 10-8-8c0 2.007.737 3.837 1.957 5.242l.916 1.056z",
    fill: "currentColor"
  })));
}
export default SvgEllipsisBubble;